window.BorderCell = function () {
    var el = this;
    
    el.data = {};

    el.init = function () {
        var cell = el._parent.workData.workareas[el.selectWorkareaId].format.cells[el.selectId];
        var color = cell.hasOwnProperty('border_color') ? cell.border_color : '#ffffff';
        $('#editor-color').colpick({
            color: color.split('#').join(''),
            submit: 0,
            onChange: el.borderCell.setColor
        }).css('background-color', color);
    };

    function update(attributes) {
        var format = el._parent.workData.workareas[el.selectWorkareaId].format;

        updateElements(attributes, el.selectWorkareaId, el.selectId);
        if (format.images.hasOwnProperty(el.selectId) && format.images[el.selectId] !== null) {
            el.mask.update(attributes.company_id, attributes.mask, el.selectWorkareaId, el.selectId);
        }
    }

    function updateElements(attributes, reversalId, cellId) {
        el._parent.svgRoot = document.getElementById('constructor-hardcover');
        var element = el.svgRoot.getElementById('border-item-' + reversalId + '-' + cellId);
        var shadowElement = el.svgRoot.getElementById('shadow-cell-' + reversalId + '-' + cellId + '-thickness');
        var imageBorder = el.svgRoot.getElementById('border-image-' + reversalId + '-' + cellId);
        var cell = el._parent.workData.workareas[reversalId].format.cells[cellId];

        if (cell !== null) {
            cell = el.updateData(attributes, cell);
            el.history.add();
            var type;
            for (type in attributes) {
                switch (type) {
                    case 'thickness':
                        if (element) {
                            element.setAttribute('x', cell.border_x);
                            element.setAttribute('y', cell.border_y);
                            element.setAttribute('width', cell.border_width);
                            element.setAttribute('height', cell.border_height);
                        }
                        if (imageBorder) {
                            imageBorder.setAttribute('x', cell.border_x);
                            imageBorder.setAttribute('y', cell.border_y);
                            imageBorder.setAttribute('width', cell.border_width);
                            imageBorder.setAttribute('height', cell.border_height);
                        }
                        break;
                    case 'shadow':
                        if (shadowElement) {
                            shadowElement.setAttribute('stdDeviation', cell.border_shadow);
                        }
                        break;
                    case 'opacity':
                        if (element) {
                            element.setAttribute('fill-opacity', cell.border_opacity);
                        }
                        break;
                    case 'color':
                        if (element) {
                            element.setAttribute('fill', cell.border_color);
                        }
                        break;
                }

                $('.js-set-border[name="' + type + '"]').val(attributes[type]);
            }
        }
    }

    el.updateData = function (attributes, cell) {
        for (var type in attributes) {
            switch (type) {
                case 'thickness':
                    cell.border_x = parseInt(cell.x) - attributes.thickness;
                    cell.border_y = parseInt(cell.y) - attributes.thickness;
                    cell.border_width = parseInt(cell.width) + 2 * attributes.thickness;
                    cell.border_height = parseInt(cell.height) + 2 * attributes.thickness;
                    break;
                case 'shadow':
                    cell.border_shadow = attributes.shadow;
                    break;
                case 'opacity':
                    cell.border_opacity = attributes.opacity;
                    break;
                case 'color':
                    cell.border_color = attributes.color;
                    break;
                case 'image':
                    cell.border_image = attributes.image;
                    break;
                case 'group_image':
                    cell.border_group_image = attributes.group_image;
                    break;
                case 'company_id':
                    cell.company_id = attributes.company_id;
                    break;
            }
        }

        return cell;
    };

    el.setColor = function (hsb, hex, rgb, element) {
        var attributes = {
            color: '#' + hex
        };

        $(element).css('background-color', attributes.color);
        update(attributes);
    };
    
    el.show = function() {
        var templateData = [];
        for (var i in el.data) {
            var grid = $.extend(true, {}, el.data[i]);
            grid['id'] = i;
            var templateThemes = [];
            for (var j in grid.themes) {
                var theme = grid.themes[j];
                var templateImages = [];

                for (var k in theme.images) {
                    var image = theme.images[k];
                    templateImages.push(image.image);
                }

                theme.images = templateImages;
                templateThemes.push(theme);
            }
            grid.themes = templateThemes;
            templateData.push(grid);
        }
        if (templateData.length > 0 ){
            templateData[0].is_active = true;
        }
        
        el.dialog.show('frames', {theme_groups: templateData});
    };
    
    el.selectFrame = function (gid, id) {
        var data = {
            company_id: el.data[gid].themes[id].company_id,
            theme_id: id,
            images: []
        };

        var i;
        var images = el.data[gid].themes[id].images;
        for (i in images) {
            if (images.hasOwnProperty(i)) {
                data.images.push({
                    filename: el.data[gid].themes[id].images[i].image,
                    mask: el.data[gid].themes[id].images[i].mask
                });
            }
        }

        $('#frame-content-1').addClass('hide');
        $('#frame-content-2').removeClass('hide');
        var html = window.Mustache.render($('#frame-images-template').html(), data);
        $('#frame-content-2 .modal-body').html(html);
    };
    
    el.set = function (companyId, groupId, name, mask) {
        var url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/souvenir/frames/' + companyId + '/' + groupId + '/workimages/' + name;
        var image = new Image();

        image.onload = function () {
            var attributes = {
                image: name,
                group_image: groupId,
                company_id: companyId,
                mask: mask
            };

            update(attributes);

            el.workarea.render();
            el.preview.update();
        };

        image.src = url;
    };
    
    $(document).on('change keyup', '.js-set-border', function () {
        var attributes = {};
        
        var value = parseFloat($(this).val());
        var min = parseFloat($(this).attr('min'));
        var max = parseFloat($(this).attr('max'));
        value = isNaN(value) || value < min ? min : value;
        value = value > max ? max : value;

        var property = $(this).attr('name');
        attributes[property] = value;
        
        if (property === 'thickness' && value === 0) {
            attributes.opacity = 0;
        }
        
        update(attributes);
    });
    
    $(document).on('click', '.js-frames-show', function () {
        el.show();
    });
    
    $(document).on('click', '.js-frame-show', function () {
        el.selectFrame($(this).attr('data-group'), $(this).attr('data-id'));
    });
    
    $(document).on('click', '.js-frame-back', function () {
        $('#frame-content-2').addClass('hide');
        $('#frame-content-1').removeClass('hide');
    });
    
    $(document).on('click', '.js-frame-set', function () {
        var element = $(this);
        el.set(element.attr('data-company'), element.attr('data-id'), element.attr('data-filename'), element.attr('data-mask'));
    });

};